import { AuthUserState } from './dto/response';

const CryptoJS = require('crypto-js');

export function encryptText(plainText: any) {
    if (!plainText) return ''
    let key = CryptoJS.enc.Utf8.parse('3d7de24152e38eb4b56dec9712f0dc1323743e1a2b18a14db72d4f11da705976');
    let iv = CryptoJS.enc.Utf8.parse('e2c84cfc673114b0f037e0fcd82d343d');
    let config = { keySize: 128, iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 };
    let encPassword = CryptoJS.AES.encrypt(plainText, key, config);
    return encPassword.ciphertext.toString(CryptoJS.enc.Base64);
}

export const decryptText = (text: any) => {
    if (!text) return ''
    let key = CryptoJS.enc.Utf8.parse('3d7de24152e38eb4b56dec9712f0dc1323743e1a2b18a14db72d4f11da705976');
    let iv = CryptoJS.enc.Utf8.parse('e2c84cfc673114b0f037e0fcd82d343d');
    let config = { keySize: 128, iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 };
    try {
        let encPassword = CryptoJS.AES.decrypt(text, key, config);
        return encPassword.toString(CryptoJS.enc.Utf8);
    } catch (err) {
        try {
            return JSON?.parse(text)
        } catch (err1) {
            return text || ''
        }
    }
}

export const isObject = (obj: any) => typeof obj === 'object' && !Array.isArray(obj) && obj !== null

export const stableSort = <T>(array: readonly T[], comparator: (a: T, b: T) => number) => {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export const getComparator = <Key extends keyof any>(order: any, orderBy: Key,): (
    a: { [key in Key]: any },
    b: { [key in Key]: any },
) => number => {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

export const descendingComparator = <T>(a: T, b: T, orderBy: keyof T) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export const isLoggedIn = (state: AuthUserState) => {
    const { token, userDetails, session_expires } = state;
    return !!userDetails && !!token && !!session_expires;
}


export const isAuthorizedPage = (authUser: any) => {
    return true
}


export const formatUserType = (userType?: string) => {
    if (!userType) return "";
    return userType
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
};


export const fabStyle = {
    borderRadius: '38px',
    '& input::placeholder': { color: 'black', opacity: 1, },
    bgcolor: '#fff',
    color: 'black',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
    '& .MuiOutlinedInput-root': {
        '& fieldset': { border: 'none' },
    },
    '& input': {
        color: 'black',
        textAlign: 'left',
    },
};
